import { Component, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { InfoBlockComponent } from '@components/info/info-block/info-block.component';
import { SlaughterhouseItem } from '@hjc/masterdata-types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'md-products-and-fillspots',
  imports: [InfoBlockComponent, MatDividerModule, TranslateModule],
  templateUrl: './products-and-fillspots.component.html',
  styleUrl: './products-and-fillspots.component.scss',
  standalone: true
})
export class ProductsAndFillspotsComponent {
  slaughterhouseItem = input<SlaughterhouseItem | undefined>(undefined);
}
